export enum LoyaltyType {
  ZUBIZU = 'Zubizu',
  KOC_AILEM = 'KocAilem',
  HOPI_BOOSTER = 'HopiBooster',
  PARO = 'Paro',
  TAV = 'Tav',
  TANI_HEDIYE_KART = 'TaniHediyeKart',
  CHIPPIN = 'Chippin',
  SETUR_HEDIYE_PUAN = 'SeturHediyePuan',
  WORLD_PUAN = 'WorldPuan',
  TURK_TELEKOM = 'TurkTelekom',
  HOPI_KAZANIM = 'HopiKazanim',
  TURK_TELEKOM_PRIME = 'TurkTelekomPrime',
  TURK_TELEKOM_PRIME_BUSINESS = 'TurkTelekomPrimeBusiness',
  SETUR_EMPLOYEE = 'SeturEmployee',
}
